import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer
      className="bg-[#FAF9F5] border-t border-[#E5E0D8] mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif-editorial text-2xl tracking-[0.25em] text-[#1E1E1E] mb-4">
            GALOLÀ
          </div>
          <p className="text-[#5C5C5C] leading-relaxed max-w-sm">
            Moda y complementos handmade. Diseño propio, piezas únicas hechas con
            tiempo, alma y materiales nobles.
          </p>
        </div>

        <div>
          <h4 className="label-tracked mb-4 text-[#1E1E1E]">Navegar</h4>
          <ul className="space-y-2 text-[#5C5C5C]">
            <li>
              <Link to="/catalogo" className="hover:text-[#C27A62] transition-colors">
                Colección
              </Link>
            </li>
            <li>
              <Link to="/sobre" className="hover:text-[#C27A62] transition-colors">
                Sobre GALOLÀ
              </Link>
            </li>
            <li>
              <Link
                to="/tips-fotografia"
                className="hover:text-[#C27A62] transition-colors"
              >
                Cómo fotografiar tus piezas
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="label-tracked mb-4 text-[#1E1E1E]">Contacto</h4>
          <ul className="space-y-3 text-[#5C5C5C]">
            <li className="flex items-center gap-2">
              <Mail size={15} />
              <a href="mailto:hola@galola.com" className="hover:text-[#C27A62]">
                hola@galola.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Instagram size={15} />
              <a
                href="https://instagram.com/galola"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#C27A62]"
              >
                @galola
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/34696295529"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#C27A62]"
                data-testid="footer-whatsapp"
              >
                WhatsApp +34 696 29 55 29
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E0D8] py-6 px-4 text-center text-xs text-[#5C5C5C]">
        © {new Date().getFullYear()} GALOLÀ — Hecho con cariño en España.
      </div>
    </footer>
  );
};

export default Footer;
